import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export const getDocuments = (userId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_CARE_PLAN_DOCUMENTS_REQUEST });

  return api.eligibility.carePlan.getDocuments(userId)
    .then((res: any) => {

      dispatch({
        type: types.GET_CARE_PLAN_DOCUMENTS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_CARE_PLAN_DOCUMENTS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getNewItemsCount = (userId: string) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.GET_NEW_CARE_PLAN_ITEMS_COUNT_REQUEST });

  return api.eligibility.carePlan.getNewItemsCount(userId)
    .then((res: any) => {

      dispatch({
        type: types.GET_NEW_CARE_PLAN_ITEMS_COUNT_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_NEW_CARE_PLAN_ITEMS_COUNT_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
